import { useMutation, useQueryClient } from "@tanstack/react-query";
import accessManagementService from "../services/accessManagementService";

export const DeleteUserMutation = (onSuccess, onError) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (userIds) => {
      const userId = userIds[0];
      return accessManagementService.removeUser(userId);
    },
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries("getAllUserList");
      onSuccess();
    },
    onError: (error) => {
      onError(error);
    },
  });
};

export const CreateUserMutation = (onSuccess, onError) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (reqBody) => {
      return accessManagementService.createNewUser(reqBody);
    },
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries("getAllUserList");
      onSuccess();
    },
    onError: (error) => {
      onError(error);
    },
  });
};

export const ChangeRolePermissionApi = (onSuccess, onError) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (reqBody) => {
      return accessManagementService.changeUserRolePermission(reqBody);
    },
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries("getAllUserAccessList");
      onSuccess();
    },
    onError: (error) => {
      onError(error);
    },
  });
};

export const ChangeUserRoleMutation = (onSuccess, onError) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (reqBody) => {
      return accessManagementService.changeUserRole(reqBody);
    },
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries("getAllUserList");
      onSuccess();
    },
    onError: (error) => {
      onError(error);
    },
  });
};

export const UpdateUserMutation = (onSuccess, onError) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (reqBody) => {
      return accessManagementService.updateUser(reqBody);
    },
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries("getAllUserList");
      onSuccess();
    },
    onError: (error) => {
      onError(error);
    },
  });
};
